var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6.785,
    height: 9.98,
    viewBox: "0 0 6.785 9.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M12.469-2.078l-.738-.437a.409.409,0,0,1-.191-.574,4.83,4.83,0,0,0,.492-2.365,5,5,0,0,0-.67-2.311A4.985,4.985,0,0,0,9.693-9.5a4.782,4.782,0,0,0-2.283-.752.477.477,0,0,1-.3-.15A.419.419,0,0,1,7-10.691v-.875a.448.448,0,0,1,.137-.328A.367.367,0,0,1,7.465-12a6.676,6.676,0,0,1,3.131,1,6.639,6.639,0,0,1,2.283,2.352,6.655,6.655,0,0,1,.9,3.172A6.7,6.7,0,0,1,13.1-2.27a.418.418,0,0,1-.273.219A.476.476,0,0,1,12.469-2.078Z",
    transform: "translate(-7 12.008)",
    fill: "#8c8b97"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.ad89b2a5828506f7a9fa1b32584af76d.svg";
export { ForwardRef as ReactComponent };